// -----------------------------
// DOM helpers
// -----------------------------

export function safeGetMeta(
  doc: Document,
  nameOrProperty: string
): string | null {
  try {
    const byName = doc.querySelector<HTMLMetaElement>(
      `meta[name="${nameOrProperty}"]`
    );
    if (byName?.content) return byName.content.trim();
    const byProp = doc.querySelector<HTMLMetaElement>(
      `meta[property="${nameOrProperty}"]`
    );
    if (byProp?.content) return byProp.content.trim();
    return null;
  } catch {
    return null;
  }
}
